'use client'

import React, { createContext, useContext } from 'react'

import { IBottomSheet } from '../../bottom-sheet'
import { useBottomSheetMethods } from '../use-bottom-sheet-methods'

interface BottomSheetContextType {
  openSuccess: (props: IBottomSheet) => void
  openError: (props: IBottomSheet) => void
  openInfo: (props: IBottomSheet) => void
  openWarning: (props: IBottomSheet) => void
  onClose: () => void
}

const BottomSheetContext = createContext<BottomSheetContextType | undefined>(
  undefined
)

export const BottomSheetProvider = ({
  children,
}: {
  children: React.ReactNode
}) => {
  const bottomSheet = useBottomSheetMethods()

  return (
    <BottomSheetContext.Provider value={bottomSheet}>
      {children}
      {bottomSheet.renderBottomSheets()}
    </BottomSheetContext.Provider>
  )
}

export const useBottomSheet = () => {
  const context = useContext(BottomSheetContext)
  if (!context) {
    throw new Error('useBottomSheet must be used within a BottomSheetProvider')
  }
  return context
}
